import { render, staticRenderFns } from "./radar_point_style.md?vue&type=template&id=0d574834&"
import script from "./radar_point_style.md?vue&type=script&lang=js&"
export * from "./radar_point_style.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d574834')) {
      api.createRecord('0d574834', component.options)
    } else {
      api.reload('0d574834', component.options)
    }
    module.hot.accept("./radar_point_style.md?vue&type=template&id=0d574834&", function () {
      api.rerender('0d574834', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/demo/radar/radar_point_style.md"
export default component.exports